export default __webpack_public_path__ + "static/eyes-14e79794ce3f07d7e533d839634ec6d7.png";